import type { Messages, MessagesAndLocale } from '@cancellation-portal/internationalization/types';
import { getItemFromLocalStorage } from '@cancellation-portal/utils/local-storage';
import axios from 'axios';
import type { Market } from '../modules/app-context/constants';
import { Locale } from '../modules/app-context/constants';
import { popPreloadedFetchOrFallback } from '../modules/preloaded-resources';
import i18n from '@cancellation-portal/internationalization/localization-settings/i18n';

// TODO: Maybe move it to developerTools namespace? Like in developer-tools.ts!
function maybeDebugPlatformLocale(): string {
  return getItemFromLocalStorage('debugPlatformLocale') || '';
}

export async function forceLoadMessagesAndLocale(locale: Locale): Promise<MessagesAndLocale> {
  let messages = {};
  // Iterate over all namespaces for the current language
  Object.keys(i18n.store.data[locale]).forEach((namespace) => {
    // @ts-ignore
    messages = { ...messages, ...i18n.store.data[locale][namespace] };
  });
  return {
    messages,
    locale,
  };
}

async function loadLocalMessagesEnglish(): Promise<MessagesAndLocale> {
  return import(/* webpackChunkName: "localized-messages-local" */ './development-localized-messages').then(
    (module) => {
      const messages: Messages = module.localizedMessagesEnglish();
      const locale = Locale.enGB;

      return { messages, locale };
    }
  );
}

export async function loadMessagesAndLocale(market?: Market): Promise<MessagesAndLocale> {
  // @ts-ignore
  if (window.Cypress) {
    let messages = {};
    const locale = Locale.enGB;
    // Iterate over all namespaces for the current language
    Object.keys(i18n.store.data['en-GB']).forEach((namespace) => {
      // @ts-ignore
      messages = { ...messages, ...i18n.store.data['en-GB'][namespace] };
    });
    return { messages, locale };
  } else if (process.env.NODE_ENV === 'development' && maybeDebugPlatformLocale() === '') {
    return loadLocalMessagesEnglish();
  } else {
    const url = `/api/v1/internationalization/messages/${encodeURIComponent(maybeDebugPlatformLocale())}`;

    return popPreloadedFetchOrFallback('messages', async () =>
      axios.get(url, { params: { market: market } }).then<MessagesAndLocale>((response) => response.data)
    );
  }
}

export async function loadMessagesAndLocaleCancellationPortal(locale: Locale): Promise<MessagesAndLocale> {
  if (process.env.NODE_ENV === 'development' && locale === Locale.enGB) {
    return loadLocalMessagesEnglish();
  } else {
    let messages = {};
    // Iterate over all namespaces for the current language
    Object.keys(i18n.store.data[locale]).forEach((namespace) => {
      // @ts-ignore
      messages = { ...messages, ...i18n.store.data[locale][namespace] };
    });
    return { messages, locale };
  }
}
